import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 25.8.",
  "description": "",
  "published": "2011-08-25T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-25-8/swizec/2284"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/20110825-083626.jpg",
        "alt": "20110825-083626.jpg"
      }}></img></p>
    <p>{`Today I learned that Ljubljana has something awesome I simply couldn't find in Palo Alto (I might not have been looking hard enough). We have a coffee culture.`}</p>
    <p>{`In the evenings when it gets a bit cooler and you can actually breathe, people start crawling out of the woodwork and into the coffee shops all over town centre.`}</p>
    <p>{`Having a cup of iced tea in the middle of this buzz, writing blogs and watching people just chill without being in a hurry ... it's pretty cool for doing creative stuff. Much better than Palo Alto where everyone seems constantly in a hurry because they're all startup people. Perhaps San Francisco has more of a chillaxed evening culture, but I got the impression in the US there's more of a Saturday/Sunday brunch culture.`}</p>
    <p>{`Another thing I learned is that jet lag can be an incredibly useful study aide. Turns out it's much easier to pull an all nighter studying for an exam when it feels like mid afternoon.`}</p>
    <p>{`Let's just hope I don't learn tomorrow that studying all night for an exam is counterproductive to passing said exam :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      